import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

import Input from "../components/TextField.js";
import userImage from "../assets/images/user.jpg";
import Map from "../assets/images/map-img.PNG";
import Sunroof from "../assets/images/sunroof.png";
import CardFooter from "../components/CardFooter.js";
import Tooltip from "@mui/material/Tooltip";
import Slider from "react-slick";
import Modal from "@mui/material/Modal";
import "slick-carousel/slick/slick.css";
import RangeSlider from "@mui/material/Slider";
import Restart from "../assets/images/restart.svg";
import { toast } from "react-toastify";
import { isIOS, isMobile } from "react-device-detect";
import constant from "../common.js";

import {
  GoogleMap,
  useJsApiLoader,
  Autocomplete,
  MarkerF,
  DrawingManagerF,
  PolygonF,
} from "@react-google-maps/api";

import { Backdrop, CircularProgress, TextField } from "@mui/material";

const containerStyle = {
  width: "100%",
  height: "calc(100vh - 365px)",
  minHeight: "290px",
};

const fullScreenStyle = {
  height: "calc(100% - 56px)",
  overflow: "hidden",
  maxHeight: "calc(100% - 56px)",
  position: "relative",
};

const STEPS = {
  HOME: 1,
  MAPS: 2,
  CALCULATE: 3,
  SAVINGS: 4,
  ESTIMATE: 5,
};

const Home = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [value, setValue] = React.useState(100);
  const [currentStep, setCurrentStep] = useState(STEPS.HOME);
  const [chatVisible, setChatVisible] = useState(true);
  const [waitingTimer, setWaitingTimer] = useState(true);
  const [hangonTimer, setHangonTimer] = useState(true);
  const [hangonVisible, setHangonVisible] = useState(false);
  const [sizingTimer, setSizingTimer] = useState(false);
  const [sizingVisible, setSizingVisible] = useState(false);
  const [checkingTimer, setCheckingTimer] = useState(false);
  const [checkingVisible, setCheckingVisible] = useState(false);
  const [savingsVisible, setSavingsVisible] = useState(false);
  const [pricingVisible, setPricingVisble] = useState(false);
  const [savingDisable, setSavingDisable] = useState(true);
  const [readyDisable, setReadyDisable] = useState(true);
  const [readyButton, setReadyButton] = useState(false);
  const [loaderVisible, setLoaderVisible] = useState(false);
  const [polygon, setPolygon] = useState();
  const [isAreaDefined, setIsAreaDefined] = useState(false);
  const [commercialRate, setCommercialRate] = useState(1);
  const [commercialRevenue, setCommercialRevenue] = useState(1);
  const [overallSavings, setOverallSavings] = useState(1);
  const [placeId, setPlaceId] = useState(null);
  const [residentialRate, setResidentialRate] = useState(1);
  const [drawingControl, setDrawingControl] = useState(true);
  const [countPolygon, setCountPolygon] = useState(0);
  const [allPolygon, setAllPolygon] = useState([]);
  const [polyPath, setPolyPath] = useState([]);
  const listenersRef = useRef([]);

  const inputRef = useRef(null);
  const polygonRef = useRef(null);
  const mapRef = useRef();
  const [map, setMap] = React.useState(null);
  const [latcoor, setLatcoor] = useState(0);
  const [longcoor, setLongcoor] = useState(0);
  const [center, setCenter] = useState({ lat: 47.448, lng: -122.308 });
  const [LocationList, setLocationList] = useState([]);
  const [polyArea, setPolyArea] = useState("");
  const [solarIrradiance, setSolarIrradiance] = useState();
  const [azimuth, setAzimuth] = useState();
  const [energy, setEnergy] = useState();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [isCommercial, setIsCommercial] = useState("false");
  const libraries = ["drawing", "places", "geometry"];
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [pathChanged, setIsPathChanged] = useState(false);
  const [isPlaceSelected, setIsPlaceSelected] = useState(false);
  const [searchResult, setSearchResult] = useState("");
  var google = window.google;

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: constant.GOOGLE_MAPS_KEY,
    libraries,
  });

  const polyDefaultPath = [
    { lat: latcoor, lng: longcoor },
    { lat: latcoor + 0.00009, lng: longcoor },
    {
      lat: latcoor + 0.00009,
      lng: longcoor + 0.00009,
    },
    { lat: latcoor, lng: longcoor + 0.00009 },
  ];

  const onLoadAutocomplete = (autocomplete) => {
    setSearchResult(autocomplete)
  }
  const handlePlaceChanged = () => {
    if (searchResult != null) {
      setIsPlaceSelected(true);
    }
    const place = searchResult.getPlace();
    if (searchResult == null) {
      return;
    }
    if (place) {
      //console.log("Places selected")

      console.log(place);
      setAddress(place.formatted_address);
      setLatcoor(place.geometry.location.lat());
      setLongcoor(place.geometry.location.lng());
      let keys = Object.keys(place);
      if (keys.includes("current_opening_hours")) {
        setIsCommercial(true);
      }
    }
  };

  const getPlacesObject = () => {
    console.log(mapRef.current);
  };

  const onPolygonComplete = (polygon) => {
    console.log("Inside complete");
    console.log("Polygon", polygon);

    polygon.getPath().addListener("set_at", () => {
      var area = google.maps.geometry.spherical.computeArea(
        polygon.getPath().getArray()
      );
      console.log("Modified Area", area);
      setPolyArea(area);
    });

    polygon.getPath().addListener("insert_at", () => {
      var area = google.maps.geometry.spherical.computeArea(
        polygon.getPath().getArray()
      );
      console.log("Modified Area", area);
      setPolyArea(area);
    });

    setCountPolygon(countPolygon + 1);
    setIsAreaDefined(true);
    if (allPolygon.length !== 0) {
      clearPreviousPolygons();
    }
    setDrawingControl(false);
    setAllPolygon([...allPolygon, polygon]);
    const google = window.google;
    var area = google.maps.geometry.spherical.computeArea(
      polygon.getPath().getArray()
    );
    setLocationList(
      polygon
        .getPath()
        .getArray()
        .map((point) => ({
          lat: point.lat(),
          lng: point.lng(),
        }))
    );
    setPolyArea(area);

    polygon.getPath().addListener("set_at", () => {
      var area = google.maps.geometry.spherical.computeArea(
        polygon.getPath().getArray()
      );
      console.log("Modified Area", area);
      setPolyArea(area);
    });

    polygon.getPath().addListener("insert_at", () => {
      var area = google.maps.geometry.spherical.computeArea(
        polygon.getPath().getArray()
      );
      console.log("Modified Area", area);
      setPolyArea(area);
    });

    setLatcoor(polygon.map.center.lat());
    setLongcoor(polygon.map.center.lng());
    setIsCommercial(false);
    setChatVisible(true);
  };

  const polygonOptions = {
    fillOpacity: 0.3,
    fillColor: "#ff0000",
    strokeColor: "#ff0000",
    strokeWeight: 2,
    draggable: false,
    editable: true,
  };

  const checkAreaSelected = () => {
    if (allPolygon.length === 0) {
      toast.error("Please select area from the Map");
    } else {
      setIsAreaDefined(true);
      return true;
    }
  };

  const removePolygon = (polygon) => {
    setPolygon(polygon);
  };

  const clearPreviousPolygons = () => {
    while (allPolygon.length) {
      var oldPolygon = allPolygon.pop();
      oldPolygon.setMap(null);
    }
  };

  const defaultDrawing = (latcoor, longcoor) => {
    clearPreviousPolygons();
    setIsAreaDefined(true);

    const polyCoordsMob = [
      { lat: latcoor, lng: longcoor },
      { lat: latcoor + 0.00009, lng: longcoor },
      { lat: latcoor + 0.00009, lng: longcoor + 0.00009 },
      { lat: latcoor, lng: longcoor + 0.00009 },
    ];

    const polyCoordsGeneral = [
      { lat: latcoor, lng: longcoor },
      { lat: latcoor + 0.0007, lng: longcoor },
      { lat: latcoor + 0.0007, lng: longcoor + 0.0007 },
      { lat: latcoor, lng: longcoor + 0.0007 },
    ];

    const polygon = new google.maps.Polygon({
      paths: [isMobile ? polyCoordsMob : polyCoordsGeneral],
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      editable: true,
    });

    polygon.setMap(map);

    setAllPolygon([...allPolygon, polygon]);
    var area = google.maps.geometry.spherical.computeArea(
      polygon.getPath().getArray()
    );
    console.log("Area", area);
    setPolyArea(area);

    polygon.getPath().addListener("set_at", () => {
      var area = google.maps.geometry.spherical.computeArea(
        polygon.getPath().getArray()
      );
      console.log("Modified Area", area);
      setPolyArea(area);
    });

    polygon.getPath().addListener("insert_at", () => {
      var area = google.maps.geometry.spherical.computeArea(
        polygon.getPath().getArray()
      );
      console.log("Modified Area", area);
      setPolyArea(area);
    });

  };

  const checkPlaceType = async () => {
    try {
      const { data } = await axios.post(
        //`http://${constant.IP_ADDRESS}:${constant.BACKEND_PORT}/getData`,
        'https://frightened-worm-singlet.cyclic.app/getData',
        {
          id: placeId,
        }
      );

      if (data) {
        var finalData = data.result;
        var arrKeys = Object.keys(finalData);
        if (arrKeys.includes("current_opening_hours")) {
          setIsCommercial(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setCenter({ lat: latcoor, lng: longcoor });
  }, [latcoor, longcoor]);

  useEffect(() => {
    console.log("All Polygons", allPolygon);
  }, [countPolygon, allPolygon]);

  useEffect(() => {
    if (placeId) {
      checkPlaceType();
    }
  }, [placeId]);

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map);
  }, []);

  //console.log("Map", map)

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const onEdit = React.useCallback(() => {
    if (polygonRef.current) {
      const nextPath = polygonRef.current
        .getPath()
        .getArray()
        .map((latLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
      setPolyPath(nextPath);
      setIsPathChanged(true);
    }
    const google = window.google;
    var area = google.maps.geometry.spherical.computeArea(
      polygonRef.current.getPath().getArray()
    );
    console.log("Modified Area", area);
    setPolyArea(area);
  }, [setPolyPath]);

  const onLoadPolygon = React.useCallback(
    (polygon) => {
      polygonRef.current = polygon;
      const path = polygon.getPath();
      listenersRef.current.push(
        path.addListener("set_at", onEdit),
        path.addListener("insert_at", onEdit),
        path.addListener("remove_at", onEdit)
      );
      const google = window.google;
      var area = google.maps.geometry.spherical.computeArea(
        polygon.getPath().getArray()
      );
      console.log("Area", area);
      setPolyArea(area);
      setAllPolygon([...allPolygon, polygon]);
      setIsAreaDefined(true);
    },
    [onEdit]
  );

  const dataHandler = async () => {
    try {
      const { data } = await axios.get(
        `https://developer.nrel.gov/api/pvwatts/v8.json?api_key=QA7v8JQNzYS5cXoBAeJWWaCrR742o508CWNrSGzK&lat=${latcoor}&lon=${longcoor}&azimuth=180&system_capacity=4&losses=14&array_type=1&module_type=0&gcr=0.4&dc_ac_ratio=1.2&inv_eff=96.0&radius=0&dataset=nsrdb&tilt=10&soiling=12|4|45|23|9|99|67|12.54|54|9|0|7.6&albedo=0.3&bifaciality=0.7`
      );
      setSolarIrradiance(data.outputs.solrad_annual);
      setAzimuth(data.inputs.azimuth);
    } catch (error) {
      console.log(error);
    }
  };

  const costHandler = async () => {
    try {
      const { data } = await axios.get(
        `https://developer.nrel.gov/api/utility_rates/v3.json?api_key=QA7v8JQNzYS5cXoBAeJWWaCrR742o508CWNrSGzK&lat=${latcoor}&lon=${longcoor}`
      );
      setCommercialRate(data.outputs.commercial);
      setResidentialRate(data.outputs.residential);
    } catch (error) {
      console.log(error);
    }
  };

  const clearDrawing = () => {
    setDrawingControl(true);
    clearPreviousPolygons();
  };

  const sendEmail = async (e) => {
    if (email == "" || phone == "" || name == "") {
      toast.error("Please fill out the mandatory details");
      return;
    } else {
      e.preventDefault();
      console.log("Inside else");
      const headers = {
        "Content-Type": "application/json",
      };

      try {
        let fullName = name;

        // Split the full name into an array ['John', 'Doe']
        let names = fullName.split(' ');

        // The first name is the first element in the array
        let firstName = names[0];

        // The last name is the second element in the array
        let lastName = names[1];



        const { data } = await axios.post(
          // `http://${constant.IP_ADDRESS}:${constant.BACKEND_PORT}/sendMail`, /// YOUR BACKEND URL

          // 'https://frightened-worm-singlet.cyclic.app/sendMail',
          // {
          //   to: email,
          //   subject: "Estimated Savings Data",
          //   text: "Your estimated savings based on the data entered is calculated as below: ",
          //   html: ` <b>Area Selected: ${polyArea.toFixed(2)}</b> <br>
          //           <b>Efficiency of Panel: 17%</b> <br>
          //           <b>Solar Irradiance: ${solarIrradiance.toFixed(3)}</b> <br>
          //           <b>Performance Ratio: 0.75</b> <br>
          //           <b>Azimuth Angle: ${azimuth}</b> <br>
          //           <b>Energy Generated by Panel: ${energy.toFixed(2)}</b> <br>
          //           <b>Total Revenue: ${commercialRevenue}</b> <br>
          //           <b>Total Savings: ${overallSavings.toFixed(2)}</b> <br>
          //   `,
          // },
          // {
          //   headers: headers,
          // }
       

           'https://frightened-worm-singlet.cyclic.app/sendToWebhook',
          {
            firstName: firstName,
            lastName: lastName,
            email: email,
            phoneNumber: phone,
            address: address
          },
          {
            headers: headers,
          }

        );

        toast.success("Details has been sent to your email address!");
        setTimeout(() => {
          window.location.reload(false);
        }, 2500);
        return true;
      } catch (error) {
        console.log(error);
      }
    }
  };

  const performCalculation = () => {
    if (isAreaDefined) {
      var energyProduced =
        Number(polyArea.toFixed(2)) *
        0.17 *
        Number(solarIrradiance.toFixed(2)) *
        0.75 *
        Number(azimuth);

      if (isCommercial) {
        var revenueGenerated = energyProduced * commercialRate;
        var annualCosts = value * 12;
        var savingsGenerated =
          revenueGenerated - annualCosts >= 0
            ? revenueGenerated - annualCosts
            : 0;

        setEnergy(energyProduced);
        if (isNaN(revenueGenerated)) {
          setCommercialRevenue("-");
        } else {
          setCommercialRevenue("$" + revenueGenerated.toFixed(2));
        }
        setOverallSavings(savingsGenerated);
      } else {
        var revenueGenerated = energyProduced * residentialRate;
        var annualCosts = value * 12;
        var savingsGenerated =
          revenueGenerated - annualCosts >= 0
            ? revenueGenerated - annualCosts
            : 0;

        setEnergy(energyProduced);
        if (isNaN(revenueGenerated)) {
          setCommercialRevenue("-");
        } else {
          setCommercialRevenue("$" + revenueGenerated.toFixed(2));
        }
        setOverallSavings(savingsGenerated);
      }
    } else {
      setPolyArea(1);
      var energyProduced =
        1 * 0.17 * Number(solarIrradiance.toFixed(2)) * 0.75 * Number(azimuth);
      console.log(energyProduced);
      setEnergy(energyProduced);
    }
  };

  const categorizePlaces = async () => {
    try {
      const { data } = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latcoor},${longcoor}&key=${constant.GOOGLE_MAPS_KEY}`
      );

      if (data) {
        var placesArray = data.results;
        var placeObj = placesArray[0];
        var id = placeObj.place_id;
        setPlaceId(id);
        console.log(id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const valueLabelFormat1 = (value) => {
    return `$${value} / month`;
  };

  const handleStep = (step) => {
    setCurrentStep(step);

    console.log("Current Step", step);

    setTimeout(() => {
      setWaitingTimer(false);
    }, 3000);

    if (step === 2) {
      setTimeout(() => {
        setSavingDisable(false);
      }, 3000);
      setTimeout(() => {
        setLoaderVisible(false);
      }, 1000);
    }

    if (step === 4) {
      setTimeout(() => {
        setHangonTimer(false);
        setHangonVisible(true);
        setSizingTimer(true);
      }, 3000);

      setTimeout(() => {
        setSizingTimer(false);
        setSizingVisible(true);
        setCheckingTimer(true);
      }, 5000);

      setTimeout(() => {
        setCheckingTimer(false);
        setCheckingVisible(true);
      }, 7000);

      setTimeout(() => {
        setChatVisible(false);
        setSavingsVisible(true);
        setReadyDisable(false);
      }, 9000);

      setTimeout(() => {
        setSavingsVisible(true);
      }, 10000);

      setTimeout(() => {
        setPricingVisble(true);
        setReadyButton(true);
      }, 12000);
    }
  };

  const enterFullScreen = () => {
    setIsFullScreen(true);
  };

  const exitFullScreen = () => {
    setIsFullScreen(false);
  };

  useEffect(() => {
    setWaitingTimer(true);
  }, [currentStep]);

  useEffect(() => {}, [hangonTimer]);

  //  slider
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    // variableWidth: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          // slidesToScroll: 1,
          slidesPerRow: 1,
          rows: 2,
          infinite: false,
        },
      },
    ],
  };

  return isLoaded ? (
    <>
      {/* header code start  */}
      <div className="header-inner">
        <a href="" target="_blank" className="logo">
        <img src="https://solateraenergy.com/wp-content/uploads/2023/04/logo_new.png" className="padded-image"></img>
        </a>
        <button type="button" className="reset-btn" onClick={handleOpen}>
          <img src={Restart} alt="img" />
        </button>
        {/* <a href="tel:(123)456-7890" className="btn-secondary">
          <svg width="14" height="17" viewBox="0 0 14 17" fill="none">
            <path
              d="M11.3712 10.6649C11.2167 10.3973 10.8744 10.3056 10.6068 10.4601L9.63464 11.0214L11.815 14.7979L12.7872 14.2366C13.0548 14.0821 13.1465 13.7399 12.992 13.4722L11.3712 10.6649Z"
              fill="#2a8eb1"
            ></path>
            <path
              d="M11.5 14.9797L9.31967 11.2032L9.10682 11.3261C8.72767 11.545 8.24285 11.4151 8.02395 11.036L5.46226 6.599C5.24336 6.21985 5.37327 5.73503 5.75242 5.51613L5.8078 5.48415L3.59695 1.65485L3.54157 1.68682C2.65828 2.37285 1.62053 5.00725 4.53581 10.0567C5.61092 11.9595 8.46634 15.6326 11.2872 15.1026L11.5 14.9797Z"
              fill="#2a8eb1"
            ></path>
            <path
              d="M3.91192 1.473L6.12277 5.3023L7.13422 4.71834C7.40185 4.56383 7.49363 4.22156 7.33911 3.95394L5.68781 1.0938C5.5333 0.826174 5.19108 0.734478 4.92345 0.888993L3.91192 1.473Z"
              fill="#2a8eb1"
            ></path>
          </svg>
          <span>(123) 456-7890</span>
          <span className="mobile-text">Call Us</span> 
        </a> */}
      </div>
      {/* header code end  */}
      <div className="home-content">
        <div className="stepper-card">
          {currentStep === STEPS.HOME && (
            <div className="card-home">
              <div className="location-bg"></div>
              <div className="user-profile">
                <div>
                  <img src={userImage} alt="img" />
                </div>
                <span className="status"></span>
              </div>
              <h5>
                Hey! I'm Laura. I'll be able to provide you with a custom solar estimate in seconds
                using satellites and map data!
              </h5>
              <div className="estimate-form">

              <Autocomplete
                  onLoad={onLoadAutocomplete}
                  onPlaceChanged={handlePlaceChanged}
                  options={{
                    componentRestrictions: {country: "us"}
                  }}
                >
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Location"
                  />
                </Autocomplete>

                <button
                  className="btn-primary"
                  onClick={() => {
                    {
                      isPlaceSelected
                        ? handleStep(STEPS.MAPS)
                        : toast.error(
                            "Please select the location from the list"
                          );
                    }
                    dataHandler();
                    costHandler();
                    setLoaderVisible(true);
                    // defaultDrawing(latcoor, longcoor);
                  }}
                >
                  Start Estimate
                </button>
              </div>
            </div>
          )}
          {/* step 1  */}
          {currentStep === STEPS.MAPS && (
            <div className="step step1">
              <div className="stepper-inner">
                <div className="form-content">
                  <div className="progress-bar">
                    <p style={{ paddingRight: "75%" }}>(Step 1 of 4)</p>
                    <div>
                      <span style={{ width: " 25%" }}></span>
                    </div>
                  </div>
                  <div className="all-chat">
                    <h5 className="note-text">
                      Please draw the area using polygon tool.{" "}
                    </h5>
                    <div className="single-chat">
                      {/* <div className="chat-avatar">
                        <img src={userImage} alt="img" />
                      </div> */}
                      <div
                        className="chat-animation"
                        style={{ display: "none" }}
                      >
                        <div className="dot-flashing"></div>
                      </div>
                      {loaderVisible && (
                        <div className="loader">
                          <Backdrop
                            sx={{
                              color: "#fff",
                              zIndex: (theme) => theme.zIndex.drawer + 1,
                            }}
                            open={true}
                          >
                            <CircularProgress color="inherit" />
                          </Backdrop>
                        </div>
                      )}
                      <div className="chat-content w-100">
                        {/* <FullScreen handle={handle}> </FullScreen> */}
                        <div
                          className={
                            isFullScreen ? "fullScreenStyle" : "testExit"
                          }
                        >
                          <GoogleMap
                            //mapContainerStyle={
                            //isFullScreen ? fullScreenStyle : containerStyle
                            //}
                            center={{ lat: latcoor, lng: longcoor }}
                            zoom={15}
                            onLoad={onLoad}
                            onUnmount={onUnmount}
                            options={{
                              streetViewControl: false,
                              mapTypeControlOptions: {
                                position:
                                  google.maps.ControlPosition.BOTTOM_CENTER,
                                style: google.maps.MapTypeControlStyle.DEFAULT,
                              },
                              mapTypeId: google.maps.MapTypeId.SATELLITE,
                            }}
                            // mapTypeId={google.maps.MapTypeId.SATELLITE}
                            onClick={(e) => {
                              setLatcoor(e.latLng.lat());
                              setLongcoor(e.latLng.lng());
                              getPlacesObject();
                              defaultDrawing(e.latLng.lat(), e.latLng.lng());
                            }}
                            ref={mapRef}
                          >
                            <>
                              <MarkerF
                                position={{ lat: latcoor, lng: longcoor }}
                                // onLoad={() => console.log("Maker Added")}
                              />
                              <PolygonF
                                options={polygonOptions}
                                //onLoad={defaultCalculation}
                                paths={pathChanged ? polyPath : polyDefaultPath}
                                onMouseUp={onEdit}
                                onLoad={onLoadPolygon}
                              />
                            </>
                            <DrawingManagerF
                              onPolygonComplete={onPolygonComplete}
                              options={{
                                polygonOptions: polygonOptions,
                                drawingControlOptions: {
                                  position:
                                    google.maps.ControlPosition.TOP_CENTER,
                                  drawingModes: [
                                    drawingControl
                                      ? google.maps.drawing.OverlayType.POLYGON
                                      : null,
                                  ],
                                  style: {
                                    backgroundColor: "white",
                                  },
                                },

                                // drawingControl: drawingControl
                              }}
                              onOverlayComplete={removePolygon}
                            />
                          </GoogleMap>
                          {isFullScreen && isIOS && (
                            <span className="fullScreenbtns">
                              <button onClick={exitFullScreen}>
                                Exit Full Screen
                              </button>
                              {isAreaDefined && (
                                <button onClick={clearDrawing}>Reset</button>
                              )}
                            </span>
                          )}
                        </div>
                        <div
                          className="map-reset-btn"
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {isIOS && !isFullScreen && (
                            <button onClick={enterFullScreen}>
                              Enter Full Screen
                            </button>
                          )}
                          {isAreaDefined && (
                            <button onClick={clearDrawing}>Reset Map</button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="all-chat" style={{ display: "none" }}>
                    <div className="single-chat">
                      <div className="chat-avatar">
                        <img src={userImage} alt="img" />
                      </div>
                      <div
                        className="chat-animation"
                        style={{ display: "none" }}
                      >
                        <div className="dot-flashing"></div>
                      </div>
                      <div className="chat-content">
                        <p>Your roof could be good for solar!</p>
                      </div>
                    </div>
                    <div className="single-chat">
                      <div className="chat-avatar">
                        <img src={userImage} alt="img" />
                      </div>
                      <div className="chat-content">
                        <div className="sunny">
                          <span>Shady</span>
                          <div className="sunny-bar"></div>
                          <span>Sunny</span>
                        </div>
                        <div className="sunroof-image-wrapper">
                          <div className="sunroof-image-container">
                            <div className="sunroof-image-main">
                              <img src={Map} alt="img" />
                            </div>
                            <img src={Sunroof} alt="img" />
                          </div>
                          <a href="#" className="not-your-home">
                            Not your home?
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="footer-btn">
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      handleStep(STEPS.HOME);
                      window.location.reload(true);
                    }}
                  >
                    <svg
                      width="12"
                      height="19"
                      viewBox="0 0 12 19"
                      fill="#2a8eb1"
                    >
                      <line
                        x1="2.31934"
                        y1="9.83908"
                        x2="9.81013"
                        y2="2.34829"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        stroke="#2a8eb1"
                      ></line>
                      <line
                        x1="1"
                        y1="-1"
                        x2="11.5936"
                        y2="-1"
                        transform="matrix(0.707107 0.707107 0.707107 -0.707107 2.31934 8.48608)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        stroke="#2a8eb1"
                      ></line>
                    </svg>
                  </button>
                  <button
                    className="btn-primary"
                    onClick={() => {
                      if (checkAreaSelected()) {
                        handleStep(STEPS.CALCULATE);
                        categorizePlaces();
                      }
                    }}
                  >
                    continue
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* step 2  */}
          {currentStep === STEPS.CALCULATE && (
            <div className="step step2">
              <div className="stepper-inner">
                <div className="form-content">
                  <div className="progress-bar">
                    <p style={{ paddingRight: "50%" }}>(Step 2 of 4)</p>
                    <div>
                      <span style={{ width: " 50%" }}></span>
                    </div>
                  </div>
                  <div className="all-chat">
                    <div className="single-chat">
                      <div className="chat-avatar">
                        <img src={userImage} alt="img" />
                      </div>
                      {waitingTimer && (
                        <div className="chat-animation">
                          <div className="dot-flashing"></div>
                        </div>
                      )}
                      {!waitingTimer && (
                        <div className="chat-content">
                          <p>What is your average electric bill payment?</p>
                        </div>
                      )}
                    </div>
                  </div>
                  {!waitingTimer && (
                    <div className="elecric-bill-slider">
                      <RangeSlider
                        min={30}
                        max={1000}
                        defaultValue={90}
                        value={value}
                        onChange={handleChange}
                        aria-label="Always visible"
                        step={5}
                        valueLabelDisplay="on"
                        valueLabelFormat={valueLabelFormat1}
                      />
                    </div>
                  )}
                </div>
                <div className="footer-btn">
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      handleStep(STEPS.HOME);
                      window.location.reload(true);
                    }}
                  >
                    <svg
                      width="12"
                      height="19"
                      viewBox="0 0 12 19"
                      fill="#2a8eb1"
                    >
                      <line
                        x1="2.31934"
                        y1="9.83908"
                        x2="9.81013"
                        y2="2.34829"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        stroke="#2a8eb1"
                      ></line>
                      <line
                        x1="1"
                        y1="-1"
                        x2="11.5936"
                        y2="-1"
                        transform="matrix(0.707107 0.707107 0.707107 -0.707107 2.31934 8.48608)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        stroke="#2a8eb1"
                      ></line>
                    </svg>
                  </button>
                  <button
                    className="btn-primary"
                    disabled={savingDisable}
                    onClick={() => {
                      handleStep(STEPS.SAVINGS);
                      performCalculation();
                    }}
                  >
                    Calculate Savings
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* step 3  */}
          {currentStep === STEPS.SAVINGS && (
            <div className="step step3">
              <div className="stepper-inner">
                <div className="form-content">
                  <div className="progress-bar">
                    <p style={{ paddingRight: "25%" }}>(Step 3 of 4)</p>
                    <div>
                      <span style={{ width: " 75%" }}></span>
                    </div>
                  </div>
                  {/* first step  */}
                  {chatVisible && (
                    <div className="all-chat">
                      <div className="single-chat">
                        {hangonTimer && (
                          <>
                            <div className="chat-avatar">
                              <img src={userImage} alt="img" />
                            </div>
                            <div className="chat-animation">
                              <div className="dot-flashing"></div>
                            </div>
                          </>
                        )}
                        {hangonVisible && (
                          <>
                            <div className="chat-avatar">
                              <img src={userImage} alt="img" />
                            </div>
                            <div className="chat-content">
                              <p>Hang on. I am calculating your savings...</p>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="single-chat">
                        {sizingTimer && (
                          <>
                            <div className="chat-avatar">
                              <img src={userImage} alt="img" />
                            </div>
                            <div className="chat-animation">
                              <div className="dot-flashing"></div>
                            </div>
                          </>
                        )}
                        {sizingVisible && (
                          <>
                            <div className="chat-avatar">
                              <img src={userImage} alt="img" />
                            </div>
                            <div className="chat-content">
                              <p>
                                Sizing your solar system based on your bill...
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="single-chat">
                        {checkingTimer && (
                          <>
                            <div className="chat-avatar">
                              <img src={userImage} alt="img" />
                            </div>
                            <div className="chat-animation">
                              <div className="dot-flashing"></div>
                            </div>
                          </>
                        )}
                        {checkingVisible && (
                          <>
                            <div className="chat-avatar">
                              <img src={userImage} alt="img" />
                            </div>
                            <div className="chat-content">
                              <p>Checking on energy prices...</p>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  {/* step 3 slider chat  */}
                  <div className="all-chat">
                    {savingsVisible && (
                      <div className="single-chat">
                        <div className="chat-avatar">
                          <img src={userImage} alt="img" />
                        </div>
                        <div className="chat-content">
                          <p>Check out these savings!</p>
                          {/* slider code  */}
                          <Slider {...settings} className="detail-slider">
                            <div className="detail-slide">
                              <h5>Area of Roof</h5>
                              <div>
                                <h4>{polyArea.toFixed(2)}</h4>
                                <p>sq. meter</p>
                              </div>
                            </div>
                            <div className="detail-slide">
                              <h5>Efficiency of Panel</h5>
                              <div>
                                <h4>17% (0.17)</h4>
                                <p>Constant</p>
                              </div>
                            </div>
                            <div className="detail-slide">
                              <h5>Solar Irradiance Variation</h5>
                              <div>
                                <h4>{solarIrradiance.toFixed(3)}</h4>
                                <p>From API Response</p>
                              </div>
                            </div>
                            <div className="detail-slide">
                              <h5>Performance Ratio</h5>
                              <div>
                                <h4>0.75</h4>
                                <p>Constant</p>
                              </div>
                            </div>
                            <div className="detail-slide">
                              <h5>Azimuth Angle</h5>
                              <div>
                                <h4>{azimuth}</h4>
                                <p>From API Response</p>
                              </div>
                            </div>
                            <div className="detail-slide">
                              <h5>Energy by Panel (KWh)</h5>
                              <div>
                                <h4>{energy.toFixed(2)}</h4>
                                <p>Calculated Energy</p>
                              </div>
                            </div>
                            <div className="detail-slide">
                              <h5>Total Revenue</h5>
                              <div>
                                <h4>{commercialRevenue}</h4>
                                <p>Calculated Revenue</p>
                              </div>
                            </div>
                            <div className="detail-slide">
                              <h5>Total Savings</h5>
                              <div>
                                <h4>${overallSavings.toFixed(2)}</h4>
                                <p>Annual Savings</p>
                              </div>
                            </div>
                          </Slider>
                        </div>
                      </div>
                    )}
                    {pricingVisible && (
                      <div className="single-chat">
                        <div className="chat-avatar">
                          <img src={userImage} alt="img" />
                        </div>
                        <div className="chat-content">
                          <p>Ready to see ballpark pricing?</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {readyButton && (
                  <div className="footer-btn">
                    <button
                      className="btn-secondary"
                      onClick={() => {
                        handleStep(STEPS.CALCULATE);
                      }}
                    >
                      <svg
                        width="12"
                        height="19"
                        viewBox="0 0 12 19"
                        fill="#2a8eb1"
                      >
                        <line
                          x1="2.31934"
                          y1="9.83908"
                          x2="9.81013"
                          y2="2.34829"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          stroke="#2a8eb1"
                        ></line>
                        <line
                          x1="1"
                          y1="-1"
                          x2="11.5936"
                          y2="-1"
                          transform="matrix(0.707107 0.707107 0.707107 -0.707107 2.31934 8.48608)"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          stroke="#2a8eb1"
                        ></line>
                      </svg>
                    </button>
                    <button
                      className="btn-primary"
                      disabled={readyDisable}
                      onClick={() => {
                        handleStep(STEPS.ESTIMATE);
                      }}
                    >
                      I'M Ready!
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
          {/* step4 */}
          {currentStep === STEPS.ESTIMATE && (
            <div div className="step step4">
              <div className="stepper-inner">
                <div className="form-content">
                  <div className="progress-bar">
                    <p style={{ paddingRight: "0%" }}>(Step 4 of 4)</p>
                    <div>
                      <span style={{ width: " 100%" }}></span>
                    </div>
                  </div>
                  <div className="all-chat">
                    <div className="single-chat">
                      <div className="chat-avatar">
                        <img src={userImage} alt="img" />
                      </div>
                      <div className="chat-content">
                        <p>
                          <b>Your online estimate is on the next page!</b> Now
                          unlock live pricing! &nbsp;
                          <span className="info-tooltip">
                            <Tooltip
                              title={
                                <div>
                                  <h6>We do not sell your information</h6>
                                  <p>
                                    Our online savings estimates are
                                    conservative. Typically, we can improve your
                                    savings estimate with more info about your
                                    property.
                                  </p>
                                </div>
                              }
                              arrow
                            >
                              <svg
                                width="19"
                                height="22"
                                viewBox="0 0 17 20"
                                fill="none"
                                data-for="tooltip"
                                data-tip="true"
                                currentitem="false"
                              >
                                <circle
                                  cx="8.5"
                                  cy="10.0625"
                                  r="8.5"
                                  fill="black"
                                ></circle>
                                <path
                                  d="M9.45112 7.584V13.246C9.45112 13.588 9.52078 13.835 9.66012 13.987C9.79945 14.1263 10.1035 14.196 10.5721 14.196V14.5H6.88612V14.177C7.40545 14.1897 7.74745 14.139 7.91212 14.025C8.07678 13.911 8.15912 13.6577 8.15912 13.265V9.123C8.15912 8.667 8.07045 8.38833 7.89312 8.287C7.71578 8.18567 7.38012 8.135 6.88612 8.135V7.793L9.12812 7.584H9.45112ZM8.82412 4.107C9.05212 4.11967 9.24212 4.20833 9.39412 4.373C9.55878 4.525 9.64112 4.715 9.64112 4.943C9.64112 5.171 9.55878 5.36733 9.39412 5.532C9.24212 5.69667 9.05212 5.779 8.82412 5.779C8.59612 5.779 8.39978 5.69667 8.23512 5.532C8.07045 5.36733 7.98812 5.171 7.98812 4.943C7.98812 4.715 8.07045 4.525 8.23512 4.373C8.39978 4.20833 8.59612 4.126 8.82412 4.126V4.107Z"
                                  fill="white"
                                ></path>
                              </svg>
                            </Tooltip>
                          </span>
                        </p>
                        <div className="user-form">
                          <form>
                            <TextField
                              label={"First and Last Name"}
                              required={true}
                              onChange={(e) => setName(e.target.value)}
                            />
                            <TextField
                              label={"Email"}
                              required={true}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            <TextField
                              label={"Mobile phone number"}
                              required={true}
                              onChange={(e) => setPhone(e.target.value)}
                            />
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="footer-btn">
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      handleStep(STEPS.SAVINGS);
                    }}
                  >
                    <svg
                      width="12"
                      height="19"
                      viewBox="0 0 12 19"
                      fill="#2a8eb1"
                    >
                      <line
                        x1="2.31934"
                        y1="9.83908"
                        x2="9.81013"
                        y2="2.34829"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        stroke="#2a8eb1"
                      ></line>
                      <line
                        x1="1"
                        y1="-1"
                        x2="11.5936"
                        y2="-1"
                        transform="matrix(0.707107 0.707107 0.707107 -0.707107 2.31934 8.48608)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        stroke="#2a8eb1"
                      ></line>
                    </svg>
                  </button>
                  <button className="btn-primary" onClick={sendEmail}>
                    Unlock Estimate
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.41248 2.50418C7.18467 2.27638 6.81533 2.27638 6.58752 2.50418C6.35972 2.73199 6.35972 3.10133 6.58752 3.32914L9.67504 6.41666H0.738889C0.330812 6.41666 0 6.67783 0 7C0 7.32216 0.330812 7.58333 0.738889 7.58333H9.67504L6.58752 10.6708C6.35972 10.8987 6.35972 11.268 6.58752 11.4958C6.81533 11.7236 7.18467 11.7236 7.41248 11.4958L11.4958 7.41247C11.7236 7.18467 11.7236 6.81532 11.4958 6.58752L7.41248 2.50418Z"
                        fill="white"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
              <p className="form-legal">
              In order for us to assist you with your transition to solar power, we require your consent to reach out. By clicking the button above, you're giving Solterra Solar the permission to communicate with you via email, phone calls, and text messages about our products. This communication might involve pre-recorded messages or the use of an autodialer, regardless of your number's presence on any "Do Not Call" list. Please note that message and data rates might apply to text messages. Giving your consent for calls and texts is completely voluntary and you have the freedom to withdraw your consent at any time.
              </p>
            </div>
          )}
          <CardFooter />
        </div>
      </div>

      {/* pop up  */}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modal-content reset-from-modal">
          <button className="close-modal" onClick={handleClose}>
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none">
              <circle
                cx="11.2014"
                cy="11.2014"
                r="11.2014"
                fill="black"
              ></circle>
              <path
                d="M16.1831 6.75598L7.29229 15.6467"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              ></path>
              <path
                d="M7.29297 6.75598L16.1837 15.6468"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              ></path>
            </svg>
          </button>
          <svg width="53" height="79" viewBox="0 0 53 79" fill="none">
            <path
              d="M25.4327 0C39.0978 0 52.5513 6.29339 52.5513 21.3467C52.5513 35.2284 36.6439 40.567 33.2277 45.583C30.6629 49.3142 31.5195 54.557 24.4728 54.557C19.8825 54.557 17.6403 50.8233 17.6403 47.4071C17.6403 34.6943 36.3189 31.8172 36.3189 21.3492C36.3189 15.5874 32.4844 12.1711 26.0752 12.1711C12.4101 12.1711 17.7461 26.2594 7.39652 26.2594C3.66029 26.2594 0.453125 24.0172 0.453125 19.7494C0.450606 9.27885 12.405 0 25.4327 0ZM24.9011 61.4878C29.698 61.4878 33.656 65.4332 33.656 70.2452C33.656 75.0572 29.7056 79.0025 24.9011 79.0025C20.0967 79.0025 16.1438 75.0622 16.1438 70.2452C16.1438 65.4357 20.0967 61.4878 24.9011 61.4878Z"
              fill="black"
            ></path>
          </svg>
          <h3>Are you sure you'd like to restart?</h3>
          <p>Your progress will be lost.</p>
          <button
            type="button"
            className="btn-primary"
            onClick={() => window.location.reload(true)}
          >
            Yes, Start Over
          </button>
        </div>
      </Modal>
    </>
  ) : (
    <></>
  );
};

export default Home;
